import { type MonthlyTourReportInvoiceExEntity, apiClient } from '@/libs/api'

export type FetchMonthlyTourReportInvoiceQuery = {
  tenantKey: string
  monthlyTourReportId: number
}

export const fetchMonthlyTourReportInvoice = async (
  { tenantKey, monthlyTourReportId }: FetchMonthlyTourReportInvoiceQuery,
  signal?: AbortSignal
): Promise<MonthlyTourReportInvoiceExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .monthly_tour_reports._id(monthlyTourReportId)
    .invoice.$get({
      config: { signal }
    })
  return data
}
